"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function ForbiddenFromJSON(json) {
    return ForbiddenFromJSONTyped(json, false);
}
exports.ForbiddenFromJSON = ForbiddenFromJSON;
function ForbiddenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !runtime_1.exists(json, 'code') ? undefined : json['code'],
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
    };
}
exports.ForbiddenFromJSONTyped = ForbiddenFromJSONTyped;
function ForbiddenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'message': value.message,
    };
}
exports.ForbiddenToJSON = ForbiddenToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9yYmlkZGVuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2dlbmVyYXRlZC9jbGllbnQvbW9kZWxzL0ZvcmJpZGRlbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0JBQW9CO0FBQ3BCLG9CQUFvQjtBQUNwQjs7Ozs7Ozs7OztHQVVHOztBQUVILHdDQUErQztBQXFCL0MsU0FBZ0IsaUJBQWlCLENBQUMsSUFBUztJQUN2QyxPQUFPLHNCQUFzQixDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztBQUMvQyxDQUFDO0FBRkQsOENBRUM7QUFFRCxTQUFnQixzQkFBc0IsQ0FBQyxJQUFTLEVBQUUsbUJBQTRCO0lBQzFFLElBQUksQ0FBQyxJQUFJLEtBQUssU0FBUyxDQUFDLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLEVBQUU7UUFDekMsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxNQUFNLEVBQUUsQ0FBQyxnQkFBTSxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDO1FBQ3hELFNBQVMsRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUM7S0FDcEUsQ0FBQztBQUNOLENBQUM7QUFURCx3REFTQztBQUVELFNBQWdCLGVBQWUsQ0FBQyxLQUF3QjtJQUNwRCxJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7UUFDckIsT0FBTyxTQUFTLENBQUM7S0FDcEI7SUFDRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDaEIsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxNQUFNLEVBQUUsS0FBSyxDQUFDLElBQUk7UUFDbEIsU0FBUyxFQUFFLEtBQUssQ0FBQyxPQUFPO0tBQzNCLENBQUM7QUFDTixDQUFDO0FBWkQsMENBWUMifQ==